export default "__VITE_ASSET__ClafZZ0G__"